// ShowStudentMissingDocumentsModal.jsx
import React from "react";
import close from "../../assets/icons/close.svg";
import SpinnerLoader from "../../Utils/Spinner";

export const ShowStudentMissingDocumentsModal = ({
  isOpen,
  onClose,
  missingDocs,
  loading,
  selectedStudentDetails,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ position: "relative", width: "40%" }}>
        {/* Header */}
        <div
          className="modal-header-content"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <h2 className="text-primary">Student Missing Documents List</h2>
          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="close" />
          </button>
        </div>

        {/* Body */}
        <div
          className="modal-body"
          style={{
            minHeight: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <SpinnerLoader />
          ) : missingDocs?.length > 0 ? (
            <ul style={{ width: "100%", marginTop: "10px" }}>
              {missingDocs.map((doc, i) => (
                <li key={i}>{doc}</li>
              ))}
            </ul>
          ) : (
            <p style={{ color: "green" }}>✅ No missing documents found.</p>
          )}
        </div>
      </div>
    </div>
  );
};
